import { BsFillBagCheckFill } from "react-icons/bs"
import { FaShippingFast, FaTruck, FaTruckLoading } from "react-icons/fa"
import { FaBoxesPacking } from "react-icons/fa6"
import { MdCancel } from "react-icons/md"
import { RiArrowGoBackFill } from "react-icons/ri"
import { TbShoppingCartCancel } from "react-icons/tb"
import DynamicCardRow from "../../../DynamicCardRow/DynamicCardRow"
import styles from "./AllOrders.module.scss"
import { Container } from "reactstrap"
import DynamicFilterBar from "../../../../common/AdminCommonComponents/FilterBars/DynamicFilterBar/DynamicFilterBar"
import { useState } from "react"
import CustomerAvatar from "../../../../../assets/images/AdminPortal/FBMManagement/customer-avatar.png"
import CustomerAvatar1 from "../../../../../assets/images/AdminPortal/FBMManagement/customer-avatar-1.png"
import DynamicDatatable from "../../../../common/AdminCommonComponents/DynamicDatatable/DynamicDatatable"
import { useNavigate } from "react-router-dom"
import ActionButton from "../../../../common/AdminCommonComponents/Buttons/ActionButton/ActionButton"
import DynamicDropdownButton from "../../../../common/AdminCommonComponents/Buttons/DynamicDropdownButton/DynamicDropdownButton"
import StatusBadge from "../../../../common/AdminCommonComponents/StatusBadge/StatusBadge"

const AllOrders = () => {
  const navigate = useNavigate()

  const orders = [
    {
      title: "RECEIVED",
      value: 0,
      icon: <FaBoxesPacking size={28} color="#FBBD34" />,
    },
    {
      title: "CONFIRMED",
      value: 0,
      icon: <BsFillBagCheckFill size={28} color="#FBBD34" />,
    },
    { title: "SHIPPED", value: 0, icon: <FaTruck size={32} color="#FBBD34" /> },
    {
      title: "OUT FOR DELIVERY",
      value: 0,
      icon: <FaShippingFast size={32} color="#FBBD34" />,
    },
    {
      title: "DELIVERED",
      value: 0,
      icon: <FaTruckLoading size={32} color="#FBBD34" />,
    },
    {
      title: "CANCELLED",
      value: 0,
      icon: <MdCancel size={28} color="#FBBD34" />,
    },
    {
      title: "RETURNED",
      value: 0,
      icon: <RiArrowGoBackFill size={28} color="#FBBD34" />,
    },
    {
      title: "FAILED",
      value: 0,
      icon: <TbShoppingCartCancel size={32} color="#FBBD34" />,
    },
  ]

  const tabsData = [
    { key: "1", label: "All" },
    { key: "2", label: "Pending" },
    { key: "3", label: "Ready to ship" },
    { key: "4", label: "Shipped" },
    { key: "5", label: "Delivered" },
    { key: "6", label: "Cancelled" },
    { key: "7", label: "Returned" },
    { key: "8", label: "Refund only" },
    { key: "9", label: "Failed delivery" },
  ]

  const [activeTab, setActiveTab] = useState(tabsData[0].key)

  const handleOptionSelect = (option) => {
    console.log("handleOptionSelect", option)
  }

  const actions = [
    {
      label: "View",
      action: () => navigate("/fbm-management/view-order-detail"),
    },
    { label: "Details", action: () => console.log("hii") },
  ]

  const tableData = [
    {
      srNo: "1",
      orderId: "#1234",
      customerName: { img: CustomerAvatar, name: "Full Name" },
      totalPayment: "$40",
      lastOrderUpdate: "04 Oct, 2024",
      status: "Shipped",
      paymentStatus: "Paid",
      orderDate: "Oct 4,2024",
    },
    {
      srNo: "2",
      orderId: "#1234",
      customerName: { img: CustomerAvatar1, name: "Full Name" },
      totalPayment: "$40",
      lastOrderUpdate: "04 Oct, 2024",
      status: "Completed",
      paymentStatus: "Unpaid",
      orderDate: "Oct 4,2024",
    },
    {
      srNo: "3",
      orderId: "#1234",
      customerName: { img: CustomerAvatar, name: "Full Name" },
      totalPayment: "$40",
      lastOrderUpdate: "04 Oct, 2024",
      status: "In Transit",
      paymentStatus: "Paid",
      orderDate: "Oct 4,2024",
    },
    {
      srNo: "4",
      orderId: "#1234",
      customerName: { img: CustomerAvatar1, name: "Full Name" },
      totalPayment: "$40",
      lastOrderUpdate: "04 Oct, 2024",
      status: "Processing",
      paymentStatus: "Unpaid",
      orderDate: "Oct 4,2024",
    },
    {
      srNo: "5",
      orderId: "#1234",
      customerName: { img: CustomerAvatar, name: "Full Name" },
      totalPayment: "$40",
      lastOrderUpdate: "04 Oct, 2024",
      status: "Deactivate",
      paymentStatus: "Paid",
      orderDate: "Oct 4,2024",
    },
  ]

  const columns = [
    { name: "Sr.", selector: (row) => row.srNo, grow: 0.5 },
    { name: "Order ID", selector: (row) => row.orderId, grow: 0.5 },
    {
      name: "Costumer name",
      cell: (row) => (
        <div className="d-flex align-items-center gap-2">
          <img src={row?.customerName?.img} alt="" width={34} height={34} />
          <div>{row?.customerName?.name}</div>
        </div>
      ),
      grow: 2,
    },
    { name: "Total payment", selector: (row) => row.totalPayment },
    { name: "Last order update", selector: (row) => row.lastOrderUpdate },
    {
      name: "Status",
      cell: (row) => <StatusBadge statusName={row.status} />,
    },
    {
      name: "Payment Status",
      cell: (row) => <StatusBadge statusName={row.paymentStatus} />,
    },
    { name: "Order Date", selector: (row) => row.orderDate },
    { name: "Action", cell: () => <ActionButton options={actions} /> },
  ]

  return (
    <>
      <div className="bg-white mt-3 shadow py-3 px-4">
        <div class="fw-semibold fs-5 mb-3">Orders</div>

        <DynamicCardRow cards={orders} />
      </div>
      <Container fluid className={styles.filterTableWrapper}>
        <div className={styles.filterDropdownWrapper}>
          <DynamicFilterBar filterTabs={tabsData} activeTab={activeTab} setActiveTab={setActiveTab} barType="default" />
          <div className={styles.dropdownButtonsRow}>
            <DynamicDropdownButton
              buttonName="Print"
              dropdownOptions={[
                { value: "pdf", label: "PDF" },
                { value: "excel", label: "Excel" },
              ]}
              onOptionSelect={handleOptionSelect}
            />
            <DynamicDropdownButton
              buttonName="Export"
              dropdownOptions={[
                { value: "csv", label: "CSV" },
                { value: "json", label: "JSON" },
              ]}
              onOptionSelect={handleOptionSelect}
            />
            <DynamicDropdownButton
              buttonName="View history"
              dropdownOptions={[
                { value: "today", label: "Today" },
                { value: "last-week", label: "Last Week" },
              ]}
              onOptionSelect={handleOptionSelect}
            />
          </div>
        </div>
        <div className={styles.tableWrapper}>
          <DynamicDatatable columns={columns} data={tableData} type="gray" pagination />
        </div>
      </Container>
    </>
  )
}

export default AllOrders
